import request from '../request'


export function getResolution(ans_id) {
    return request({
        url: `answer/mobile/resolution?ans_id=${ans_id}`,
        method: 'get',

    })
}